import { Fragment, memo } from "react";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { isAuthenticatedSelector } from "store/auth";
import { globalsSelector } from "store/globals";
import LocaleLink from "views/components/LocaleLink";

const FooterStaticPages = ({ className = "", separator }) => {
	const { t } = useTranslation();

	// redux global state
	const globals = useSelector(globalsSelector);
	const isAuthenticated = useSelector(isAuthenticatedSelector);

	return (
		<nav aria-label={t("titles.helper_pages_navigation")}>
			<ul className={`list-unstyled mb-0 ${className}`}>
				{globals?.pages?.length &&
					globals?.pages?.map(({ slug, title }, index) => (
						<Fragment key={slug}>
							<li>
								<LocaleLink
									to={`/page/${slug}`}
									className="fw-light text-capitalize text-reset small"
									aria-label={t("titles.title_page", { title })}
									title={t("actions.see_our_title", { title })}>
									<small>{title}</small>
								</LocaleLink>
							</li>
							{separator && index < globals?.pages?.length - 1 ? (
								<li>
									<div className="vr d-block" aria-hidden="true"></div>
								</li>
							) : (
								<></>
							)}
						</Fragment>
					))}
				{!isAuthenticated ? (
					<>
						{separator && globals?.pages?.length ? (
							<li>
								<div className="vr d-block" aria-hidden="true"></div>
							</li>
						) : (
							<></>
						)}
						<li>
							<LocaleLink
								to="/careers"
								className="fw-light text-capitalize text-reset small"
								aria-label={t("titles.title_page", { title: t("actions.careers") })}
								title={t("actions.see_our_title", { title: t("actions.careers") })}>
								<small>{t("actions.careers")}</small>
							</LocaleLink>
						</li>
					</>
				) : (
					<></>
				)}
			</ul>
		</nav>
	);
};

export default memo(FooterStaticPages);
